import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const AddDictionaryItemSemitrailer = ({
    show,
    onChangeAddItemFormVisibilityHandler,
    addNewEventNotificationCallback,
    userData
}) => {
    const [NewItem, setNewItem] = useState({});
    const [errors, setErrors] = useState("");
    const [isValidForm, setIsValidForm] = useState(true);
    const { t } = useTranslation();

    const hideModal = () => {
        setNewItem({});
        setErrors("");
        setIsValidForm(true);
        onChangeAddItemFormVisibilityHandler(false);
    };

    const onInputChange = (event) => {
        const { name, value } = event.target;

        setNewItem(prev => {
            const updatedItem = { ...prev, [name]: value };

            if (!isValidForm) {
                apiRequests.getDataByUrlWithParam('webconapi/AddNewSemitrailerValidate', updatedItem, newItemCallback);
            }

            return updatedItem;
        });
    };

    const onFormSubmit = (event) => {
        event.preventDefault();

        const newItem = {
            ...NewItem,
            CompanyWorkflowId: userData.CompanyWorkflowId + "",
            AccountWorkflowId: userData.AccountWorkflowId + ""
        };

        apiRequests.getDataByUrlWithParam('webconapi/AddNewSemitrailer', newItem, newItemCallback);
    };

    const newItemCallback = (data, response) => {
        if (response.status === 400) {
            if (data.errors) {
                setIsValidForm(false);
                setErrors(data.errors);
            }
        } else if (response.status === 200) {
            if (data.Message === "ok") {
                hideModal();
            } else {
                setErrors("");
            }
        }

        addNewEventNotificationCallback();
    };

    return (
        <Modal show={show} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{t('semitrailers.modal.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="new-ev-not-form" className="form-font" onSubmit={onFormSubmit}>
                    <div className="mb-3">
                        <label htmlFor="registationNumber" className="form-label m-0 p-0">
                            <sup className="text-danger">*</sup>{t('semitrailers.modal.registrationLabel')}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="registationNumber"
                            name="RegistationNumber"
                            onChange={onInputChange}
                        />
                        <span className="text-danger">
                            {errors.RegistationNumber ? errors.RegistationNumber[0] : ""}
                        </span>
                    </div>

                    <div className="mb-3 d-none">
                        <label htmlFor="semitrailerType" className="form-label m-0 p-0">
                            {t('semitrailers.modal.typeLabel')}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="semitrailerType"
                            name="SemitrailerType"
                            onChange={onInputChange}
                        />
                        <span className="text-danger">
                            {errors.SemitrailerType ? errors.SemitrailerType[0] : ""}
                        </span>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form="new-ev-not-form" type="submit" className="btn btn-primary">
                    {t('common.add')}
                </button>
                <Button variant="secondary" onClick={hideModal}>
                    {t('common.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddDictionaryItemSemitrailer;
